class FaqCbc extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (detail.open) this.closeOthers(detail);
      });
    });
  }

  closeOthers(openDetail) {
    this.querySelectorAll('details[open]').forEach((detail) => {
      if (detail !== openDetail) detail.removeAttribute('open');
    });
  }
}

customElements.define('faq-cbc', FaqCbc);
